import Ajmal_Makan_Sharjah_Waterfront_master_plan from "../assets/area/Ajmal_Makan_Sharjah_Waterfront_master_plan.png";
import Al_Mamsha_Sharjah_modern_apartments from "../assets/area/Al_Mamsha_Sharjah_modern_apartments.jpeg";
import Al_Zahia_Sharjah_community_exterior from "../assets/area/Al_Zahia_Sharjah_community_exterior.jpg";
import Aljada_Sharjah_master_plan_aerial from "../assets/area/Aljada_Sharjah_master_plan_aerial.jpeg";
import Maryam from "../assets/area/Maryam.jpg";
import Sharjah_Sustainable_City_eco_community_aerial from "../assets/area/Sharjah_Sustainable_City_eco_community_aerial.jpeg";
import Hayyan from "../assets/area/Hayyan.jpg";
import Masaar from "../assets/area/Masaar.jpeg";
import AlTaiHills from "../assets/area/AlTaiHills.jpg";
import Faradis from "../assets/area/Faradis.jpg";
import Madain from "../assets/area/Madain.jpg";
import Khalid from "../assets/area/Khalid.png";
import Tiger from "../assets/area/Tiger.jpg";
import Shoumous from "../assets/area/Shoumous.jpg";
import Ajmal from "../assets/area/Ajmal.jpg";
import Hawa from "../assets/area/Hawa.jpg";
import Binghatti from "../assets/area/Binghatti.jpg";
import TigerProjects from "../assets/area/TigerProjects.jpg";
import Azizi from "../assets/area/Azizi.jpeg";
import district11 from "../assets/New/district11.jpg";
// AJMA
import Tiger_Ajman_Downtown_high_rise_buildings from "../assets/area/Tiger_Ajman_Downtown_high_rise_buildings.webp";

// DUBAI

export const areasData = [
  // SHARJAH
  {
    id: 1,
    title: "Aljada",
    image: Aljada_Sharjah_master_plan_aerial,
    description:
      "Sharjah’s flagship urban destination with modern communities.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah%2Faljada",
    mapLink: "https://maps.google.com/?q=Aljada+Sharjah",
  },
  {
    id: 2,
    title: "Al Mamsha",
    image: Al_Mamsha_Sharjah_modern_apartments,
    description:
      "Contemporary, walkable living with premium lifestyle amenities.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah%2Fmuwaileh%2Fal-mamsha",
    mapLink: "https://maps.google.com/?q=Al+Mamsha+Sharjah",
  },
  {
    id: 3,
    title: "Al Zahia",
    image: Al_Zahia_Sharjah_community_exterior,
    description: "Family-focused community with retail, parks, and leisure.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah%2Fmuwaileh%2Fal-zahia",
    mapLink: "https://maps.google.com/?q=Al+Zahia+Sharjah",
  },
  {
    id: 4,
    title: "Hayyan",
    image: Hayyan,
    description: "Nature-inspired villa community focused on wellness living.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah%2Fhayyan",
    mapLink: "https://maps.google.com/?q=Hayyan+Sharjah",
  },
  {
    id: 5,
    title: "Masaar (Phase 1, 2 & 3)",
    image: Masaar,
    description: "Forest living community with smart homes and green trails.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah%2Fmasaar",
    mapLink: "https://maps.google.com/?q=Masaar+Sharjah",
  },
  {
    id: 6,
    title: "Sharjah Sustainable City",
    image: Sharjah_Sustainable_City_eco_community_aerial,
    description: "Eco-conscious solar-powered sustainable community.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah%2Fal-rahmaniya%2Fsharjah-sustainable-city",
    mapLink: "https://maps.google.com/?q=Sharjah+Sustainable+City",
  },
  {
    id: 7,
    title: "Al Tai Hills",
    image: AlTaiHills,
    description:
      "Upcoming residential development with long-term growth value.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah%2Fal-tai",
    mapLink: "https://maps.google.com/?q=Al+Tai+Sharjah",
  },
  {
    id: 8,
    title: "Maryam Island",
    image: Maryam,
    description: "Luxury waterfront apartments with premium lifestyle.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah%2Fal-khan%2Fmaryam-island",
    mapLink: "https://maps.google.com/?q=Maryam+Island+Sharjah",
  },
  {
    id: 9,
    title: "Faradis Tower",
    image: Faradis,
    description: "High-rise residential tower offering modern urban living.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah",
    mapLink: "https://maps.google.com/?q=Faradis+Tower+Sharjah",
  },
  {
    id: 10,
    title: "Madain",
    image: Madain,
    description: "Large-scale residential development by Sharjah Holding.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah",
    mapLink: "https://maps.google.com/?q=Madain+Sharjah",
  },
  {
    id: 11,
    title: "Khalid Bin Sultan City",
    image: Khalid,
    description: "Mixed-use city project redefining Sharjah urban living.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah",
    mapLink: "https://maps.google.com/?q=Khalid+Bin+Sultan+City",
  },
  {
    id: 12,
    title: "Shoumous",
    image: Shoumous,
    description: "Affordable and modern residential development in Sharjah.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah",
    mapLink: "https://maps.google.com/?q=Shoumous+Sharjah",
  },
  {
    id: 13,
    title: "Ajmal Makan – Sharjah Waterfront",
    image: Ajmal,
    description: "Island-style waterfront city with villas and apartments.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah%2Fsharjah-waterfront-city",
    mapLink: "https://maps.google.com/?q=Ajmal+Makan+Sharjah",
  },
  {
    id: 14,
    title: "Hawa Residence",
    image: Hawa,
    description: "Modern residential project with premium finishing.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah",
    mapLink: "https://maps.google.com/?q=Hawa+Residence+Sharjah",
  },
  {
    id: 15,
    title: "District 11 – Al Marwan",
    image: district11,
    description: "Master-planned residential zone by Al Marwan Developer.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fsharjah",
    mapLink: "https://maps.google.com/?q=District+11+Sharjah",
  },

  // AJMAN
  {
    id: 16,
    title: "Tiger Ajman Downtown",
    image: Tiger,
    description: "Urban high-rise living in Ajman city center.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fajman",
    mapLink: "https://maps.google.com/?q=Tiger+Ajman+Downtown",
  },

  // DUBAI (DEVELOPER PROJECTS)
  {
    id: 17,
    title: "Binghatti Projects – Dubai",
    image: Binghatti,
    description: "Iconic architectural residential projects across Dubai.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fdubai",
    mapLink: "https://maps.google.com/?q=Binghatti+Dubai",
  },
  {
    id: 18,
    title: "Tiger Projects – Dubai",
    image: TigerProjects,
    description: "Affordable luxury developments across key Dubai locations.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fdubai",
    mapLink: "https://maps.google.com/?q=Tiger+Dubai+Projects",
  },
  {
    id: 19,
    title: "Azizi Projects – Dubai",
    image: Azizi,
    description: "High-demand residential and mixed-use developments.",
    viewLink:
      "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238/?locations=%2Fdubai",
    mapLink: "https://maps.google.com/?q=Azizi+Developments+Dubai",
  },
];

export const areasDataDetailed = [
  {
    id: 1, // MUST MATCH areasData id
    tagline: "Scenic Views • Vibrant Lifestyle • Smart Living",

    price: "AED 770,000",
    address: "The Boulevard 3, The Boulevard, Naseej District, Aljada, Sharjah",

    propertyInfo: {
      type: "Apartment",
      purpose: "For Sale",
      beds: "1 Bed",
      baths: "2 Baths",
      size: "739 sqft",
      completion: "Ready",
      reference: "Bayut - 104238-JrI494",
      averageRent: "AED 55,474 / Year",
      addedOn: "5 January 2026",
    },

    overview: `
Aljada is a landmark master-planned destination redefining modern living in Sharjah.
Inspired by heritage districts, it blends contemporary design, greenery, and world-class amenities.

Located in New Sharjah, residences overlook landscaped courtyards and green spaces,
offering a lifestyle that is both connected and serene.
    `,

    highlights: [
      "Fully integrated urban community",
      "Smart home features as standard",
      "Landscaped courtyards & jogging tracks",
      "Family-friendly environment",
      "Designed for modern lifestyles",
    ],

    amenities: [
      "Swimming pools & fitness centers",
      "Children’s play areas",
      "Central Hub by Zaha Hadid Architects",
      "Retail & dining outlets",
      "Drive-in cinema & cultural attractions",
      "On-site hotels (ROVE, VIDA, Address)",
    ],

    locationAdvantages: [
      "On Sheikh Mohammed bin Zayed Road",
      "2 min from City Centre Al Zahia",
      "3 min from University City",
      "5 min from Sharjah Airport",
      "15 min from Dubai International Airport",
    ],
  },

  {
    id: 2, // MUST MATCH areasData id
    tagline: "Move-In Now • Walkable Community • Urban Lifestyle",

    price: "AED On Request",
    address: "RA 4, Souks Residential, Al Mamsha, Muwaileh, Sharjah",

    propertyInfo: {
      type: "Apartment",
      purpose: "For Sale",
      beds: "2 Beds",
      baths: "3 Baths",
      size: "1,823 sqft",
      completion: "Ready",
      reference: "Bayut - 104238-3e1Hgd",
      averageRent: "AED 121,209 / Year",
      addedOn: "5 January 2026",
    },

    overview: `
Al Mamsha is Sharjah’s first fully walkable community, offering a unique blend of modern living,
vibrant retail, and leisure experiences. Designed with contemporary architecture and lush landscapes,
it redefines urban living with a strong focus on comfort, convenience, and sustainability.

Stylish apartments feature premium finishes, smart home technologies, and thoughtfully designed
layouts. With retail, cafés, and restaurants at your doorstep, Al Mamsha seamlessly integrates
residential, commercial, and leisure living into one dynamic destination.

More than just a residence, Al Mamsha is a lifestyle hub where pedestrian-friendly streets,
community-driven spaces, and sustainable practices create a vibrant and inclusive environment.
    `,

    highlights: [
      "Sharjah’s first fully walkable community",
      "Modern contemporary architecture",
      "Smart home enabled apartments",
      "Urban lifestyle with retail at doorstep",
      "Ideal for families & professionals",
    ],

    amenities: [
      "Balcony or terrace",
      "Swimming pools",
      "Fitness centers",
      "Children’s play areas",
      "Centrally air-conditioned",
      "Central heating",
      "Double glazed windows",
      "Dedicated community spaces",
    ],

    locationAdvantages: [
      "Prime location in Muwaileh, New Sharjah",
      "Easy access to major highways",
      "Close to Sharjah International Airport",
      "Seamless connectivity to Dubai",
      "Surrounded by retail & lifestyle hubs",
    ],
  },
  {
    id: 3, // MUST MATCH areasData id
    tagline: "Gated Luxury • Family Living • Prime Sharjah Location",

    price: "AED 3,000,000",
    address: "Al Yasmeen, Al Zahia, Muwaileh, Sharjah",

    propertyInfo: {
      type: "Townhouse",
      purpose: "For Sale",
      beds: "3 Beds",
      baths: "4 Baths",
      size: "2,793 sqft",
      completion: "Ready",
      reference: "Bayut - 104238-9lGBJn",
      averageRent: "AED 152,367 / Year",
      addedOn: "31 December 2025",
    },

    overview: `
Al Zahia is Sharjah’s most prestigious gated community, thoughtfully master-planned
to offer luxury, comfort, and a vibrant lifestyle. Designed for families, professionals,
and investors, the community blends contemporary architecture with lush green spaces
and premium amenities.

With retail plazas, landscaped parks, and cultural events throughout the year,
Al Zahia is more than just a residential address—it’s a lifestyle destination that
prioritizes wellness, connectivity, and sustainability.
  `,

    highlights: [
      "Secure gated community with 24/7 security",
      "Wide range of apartments, townhouses & villas",
      "Landscaped parks & jogging tracks",
      "Retail plaza with cafés & dining",
      "Eco-friendly & sustainable design",
    ],

    amenities: [
      "Clubhouse with gym & swimming pool",
      "Community center for events",
      "Sports courts & fitness zones",
      "Children’s play areas",
      "Pet-friendly community spaces",
    ],

    locationAdvantages: [
      "Prime Muwaileh location in Sharjah",
      "Easy access to Dubai & other Emirates",
      "Close to City Centre Al Zahia",
      "Near schools, universities & hospitals",
      "Excellent highway connectivity",
    ],
  },

  {
    id: 4, // MUST MATCH areasData id
    tagline: "Nature-Inspired Living • Spacious Homes • Family Community",

    price: "AED On Request",
    address: "Hayyan Community, Sharjah",

    propertyInfo: {
      type: "Townhouse & Villa",
      purpose: "For Sale",
      beds: "2 to 6 Beds",
      baths: "3 to 7 Baths",
      size: "1,800 – 9,500 sqft",
      completion: "Ready",
      reference: "Hayyan - Vision X Nexus",
      averageRent: "High Rental Demand",
      addedOn: "January 2026",
    },

    overview: `
Hayyan is a nature-inspired residential community that harmoniously blends modern
architecture with lush green landscapes. Designed to promote well-being and tranquility,
the community offers spacious townhouses and villas surrounded by parks and open spaces.

Perfect for families, Hayyan delivers a balanced lifestyle with premium amenities,
high-quality construction, and a strong focus on sustainability and connectivity.
  `,

    highlights: [
      "Nature-integrated master-planned community",
      "Spacious townhouses & luxury villas",
      "High-quality finishes & smart home features",
      "Family-friendly & peaceful environment",
      "Sustainable living initiatives",
    ],

    amenities: [
      "Central park & landscaped green spaces",
      "Swimming pools for adults & children",
      "Fitness centers & jogging tracks",
      "Community clubhouse",
      "Retail outlets within the community",
    ],

    locationAdvantages: [
      "Prime Sharjah location",
      "Easy access to major highways",
      "Close to schools & universities",
      "Nearby healthcare facilities",
      "Well-connected to Sharjah & beyond",
    ],
  },

  {
    id: 5, // MUST MATCH areasData id
    tagline: "Forest Living • Modern Luxury • High Investment Potential",

    price: "AED On Request",
    address: "Masaar Community, Sharjah",

    propertyInfo: {
      type: "Townhouse & Villa",
      purpose: "For Sale",
      beds: "2 to 6 Beds",
      baths: "3 to 7 Baths",
      size: "1,800 – 9,500 sqft",
      completion: "Ready",
      reference: "Masaar - Vision X Nexus",
      averageRent: "Strong Rental Yield",
      addedOn: "January 2026",
    },

    overview: `
Masaar is Sharjah’s premier forest-living community, offering an exceptional lifestyle
where modern luxury meets nature. Surrounded by lush greenery and walking trails,
the community is designed to deliver privacy, wellness, and connectivity.

With contemporary residences, smart home integration, and world-class amenities,
Masaar stands out as one of Sharjah’s most desirable residential and investment destinations.
  `,

    highlights: [
      "Exclusive forest-themed gated community",
      "Modern architecture with smart home features",
      "Wide range of townhouses & villas",
      "Strong investment & rental potential",
      "Tranquil yet well-connected location",
    ],

    amenities: [
      "State-of-the-art fitness center",
      "Swimming pools",
      "Children’s play areas",
      "Community clubhouse",
      "Walking & cycling tracks",
    ],

    locationAdvantages: [
      "Strategic Sharjah location",
      "Easy access to Dubai",
      "Close to schools & healthcare facilities",
      "Surrounded by green landscapes",
      "Excellent long-term growth potential",
    ],
  },
  {
    id: 6,
    tagline: "Eco-Friendly Living • Smart Homes • Future-Ready Community",

    price: "AED On Request",
    address: "Sharjah Sustainable City, Sharjah",

    propertyInfo: {
      type: "Townhouse & Villa",
      purpose: "For Sale",
      beds: "Multiple Options",
      baths: "Multiple Options",
      size: "Various Sizes",
      completion: "Ready",
      reference: "Sharjah Sustainable City - VXN",
      averageRent: "High Demand",
      addedOn: "January 2026",
    },

    overview: `
Sharjah Sustainable City is a pioneering eco-friendly community where modern comfort
meets environmental responsibility. Designed with sustainability at its core,
the community offers smart homes, renewable energy solutions, and green open spaces.

This future-ready destination promotes wellness, innovation, and responsible living,
making it ideal for families and forward-thinking investors.
  `,

    highlights: [
      "Eco-friendly smart homes",
      "Energy-efficient community design",
      "Cycling tracks & jogging paths",
      "Schools, nurseries & retail within community",
      "Future-focused sustainable initiatives",
    ],

    amenities: [
      "Community center",
      "Swimming pools",
      "Gyms & wellness facilities",
      "Green parks & open spaces",
      "Retail & dining outlets",
    ],

    locationAdvantages: [
      "Strategic Sharjah location",
      "Easy access to Dubai",
      "Well-connected road network",
      "Self-sufficient lifestyle destination",
    ],
  },

  {
    id: 7,
    tagline: "Modern Villa • Family Living • Prime Al Tai Location",

    price: "AED 1,600,000",
    address: "Nasma Residence, Al Tai, Sharjah",

    propertyInfo: {
      type: "Villa",
      purpose: "For Sale",
      beds: "3 Beds",
      baths: "4 Baths",
      size: "1,455 sqft",
      completion: "Ready",
      reference: "Bayut - 104238-rcDAOg",
      averageRent: "AED 61,411 / Year",
      addedOn: "16 October 2024",
    },

    overview: `
Nasma Residence is a master-planned family community offering contemporary villas
surrounded by lush green spaces. Designed for privacy, security, and convenience,
it delivers a peaceful yet connected lifestyle in Sharjah.
  `,

    highlights: [
      "Smart home enabled villas",
      "Family-friendly community",
      "Modern architectural design",
      "Excellent connectivity",
    ],

    amenities: [
      "Community clubhouse & gym",
      "Swimming pools",
      "Parks & play areas",
      "Retail outlets",
      "Jogging & cycling tracks",
    ],

    locationAdvantages: [
      "10 minutes from Sharjah Airport",
      "15 minutes to University City",
      "20 minutes to Dubai Airport",
      "Near schools & healthcare",
    ],
  },

  {
    id: 8,
    tagline: "Waterfront Living • Modern Design • Immediate Occupancy",

    price: "AED 770,000",
    address: "Noor Residences, Maryam Island, Al Khan, Sharjah",

    propertyInfo: {
      type: "Apartment",
      purpose: "For Sale",
      beds: "1 Bed",
      baths: "2 Baths",
      size: "783 sqft",
      completion: "Ready",
      reference: "Bayut - 104238-o9jd0y",
      averageRent: "AED 61,903 / Year",
      addedOn: "22 December 2025",
    },

    overview: `
Maryam Island is Sharjah’s premier waterfront destination combining luxury residences,
retail, hospitality, and leisure. Offering breathtaking sea views and a vibrant promenade,
it blends coastal elegance with urban convenience.
  `,

    highlights: [
      "Waterfront lifestyle",
      "Freehold residences",
      "Retail, cafés & promenade",
      "Strong rental demand",
    ],

    amenities: [
      "Swimming pools",
      "Fitness clubs & spas",
      "Children play areas",
      "Retail & dining outlets",
    ],

    locationAdvantages: [
      "Downtown Sharjah location",
      "Minutes from Dubai Airport",
      "Easy road connectivity",
    ],
  },

  {
    id: 9,
    tagline: "Forest Living • Family Friendly • Premium Townhouse",

    price: "AED 2,450,000",
    address: "Robinia, Masaar, Tilal City, Sharjah",

    propertyInfo: {
      type: "Townhouse",
      purpose: "For Sale",
      beds: "3 Beds",
      baths: "4 Baths",
      size: "2,591 sqft",
      completion: "Ready",
      reference: "Bayut - 104238-thuDDL",
      averageRent: "AED 139,188 / Year",
      addedOn: "19 December 2025",
    },

    overview: `
Masaar is a forest-inspired master community designed for wellness, privacy,
and sustainable living. With thousands of trees, scenic trails, and premium amenities,
it offers a refined lifestyle surrounded by nature.
  `,

    highlights: [
      "Forest-themed master community",
      "Family-first planning",
      "Wellness & leisure amenities",
      "High investment appeal",
    ],

    amenities: [
      "Clubhouse & gym",
      "Swimming pools",
      "Cycling & jogging tracks",
      "Children play areas",
    ],

    locationAdvantages: [
      "Easy access to E611",
      "15 minutes to Sharjah Airport",
      "20 minutes to Dubai Airport",
    ],
  },

  {
    id: 10,
    tagline: "Quiet Community • Modern Townhouse • Masaar Living",

    price: "AED 2,150,000",
    address: "Sendian Villas, Masaar, Tilal City, Sharjah",

    propertyInfo: {
      type: "Townhouse",
      purpose: "For Sale",
      beds: "3 Beds",
      baths: "4 Baths",
      size: "2,256 sqft",
      completion: "Ready",
      reference: "Bayut - 104238-W0DGMY",
      averageRent: "AED 121,189 / Year",
      addedOn: "5 January 2026",
    },

    overview: `
Sendian Villas offer peaceful living within Masaar’s green master-planned environment,
ideal for families seeking privacy, comfort, and modern design.
  `,

    highlights: [
      "Nature-integrated living",
      "Modern townhouse layouts",
      "High rental potential",
    ],

    amenities: ["Pools & gym", "Parks & trails", "Community clubhouse"],

    locationAdvantages: [
      "Connected to Dubai & Sharjah",
      "Near schools & healthcare",
    ],
  },

  {
    id: 11,
    tagline: "City Living • Smart Homes • Aljada Lifestyle",

    price: "AED 770,000",
    address: "The Boulevard 3, Aljada, Sharjah",

    propertyInfo: {
      type: "Apartment",
      purpose: "For Sale",
      beds: "1 Bed",
      baths: "2 Baths",
      size: "739 sqft",
      completion: "Ready",
      reference: "Bayut - 104238-JrI494",
      averageRent: "AED 55,474 / Year",
      addedOn: "5 January 2026",
    },

    overview: `
Aljada is Sharjah’s most vibrant urban destination, combining smart homes,
green spaces, entertainment, and cultural attractions into one integrated city.
  `,

    highlights: [
      "Fully integrated urban community",
      "Smart home features",
      "Central Hub by Zaha Hadid",
    ],

    amenities: [
      "Swimming pools & gyms",
      "Retail & dining",
      "Drive-in cinema",
      "Hotels & leisure zones",
    ],

    locationAdvantages: [
      "On Sheikh Mohammed bin Zayed Road",
      "2 minutes from City Centre Al Zahia",
    ],
  },

  {
    id: 12,
    tagline: "Family Villas • Green Community • Strong Investment",

    price: "AED On Request",
    address: "Shoumous Community, Sharjah",

    propertyInfo: {
      type: "Villa",
      purpose: "For Sale",
      beds: "3 to 5 Beds",
      baths: "4 to 6 Baths",
      size: "3,150 – 5,600 sqft",
      completion: "Ready",
      reference: "Shoumous - VXN",
      averageRent: "Growing Demand",
      addedOn: "January 2026",
    },

    overview: `
Shoumous is an exclusive residential community offering spacious villas designed
for family living. Blending modern comfort with traditional charm, it delivers
a serene yet well-connected lifestyle in Sharjah.
  `,

    highlights: [
      "Spacious family villas",
      "Smart home integration",
      "Green landscaped parks",
      "Strong investment potential",
    ],

    amenities: [
      "Swimming pool",
      "Fitness center",
      "Children play areas",
      "Community center",
      "24/7 security",
    ],

    locationAdvantages: [
      "Easy access to Emirates Road",
      "30 minutes to Dubai Airport",
      "Near schools & hospitals",
    ],
  },
];
